import React, { useMemo } from 'react';
import { Column } from '../../../components/ui/paginated-table';
import PaginatedTableComponent from '../../../components/ui/paginated-table';
import JsonCell from '../../../components/ui/json-cell';
import { TableChangesLog } from '../../../resources/audit-log/audit-log.types';
import { dateToCorrectTimezone } from '../../../utils/execution-utils';

interface Props {
  rows: TableChangesLog[] | null | undefined;
  total: number;
  loading: boolean;
  selectedPage: number;
  setSelectedPage: (page: number) => void;
  loadPage: (page: any) => Promise<any>;
  limit: number;
}

export const AuditLogList: React.FC<Props> = ({
                                                rows,
                                                total,
                                                loading,
                                                selectedPage,
                                                setSelectedPage,
                                                loadPage,
                                                limit
                                              }) => {

  const columns = useMemo<Column[]>(() => [
    {
      id: 'logId',
      label: 'ID',
      minWidth: 60
    },
    {
      id: 'tableName',
      label: 'Table Name',
      minWidth: 150
    },
    {
      id: 'operation',
      label: 'Operation',
      minWidth: 100,
      format: (val: string) => <span style={{ fontWeight: 'bold' }}>{val}</span>
    },
    {
      id: 'changedBy',
      label: 'Changed By',
      minWidth: 150
    },
    {
      id: 'changedDt',
      label: 'Date',
      minWidth: 160,
      format: (value: string) => dateToCorrectTimezone(value)
    },
    {
      id: 'oldData',
      label: 'Old Data',
      minWidth: 220,
      format: (val: string) => <JsonCell value={val} />
    },
    {
      id: 'newData',
      label: 'New Data',
      minWidth: 220,
      format: (val: string) => <JsonCell value={val} />
    },
    {
      id: 'dataDiff',
      label: 'Diff',
      minWidth: 220,
      format: (val: string) => <JsonCell value={val} />
    }
  ], []);

  return (
    <PaginatedTableComponent
      columns={columns}
      rows={loading ? null : rows}
      rowIdPropName="logId"
      selectedPage={selectedPage}
      setSelectedPage={setSelectedPage}
      totalCount={total}
      loadPage={loadPage}
      selectable={false}
      noResultsHeader="No records found"
      selectedRowsPerPage={limit}
      showAllOption={false}
    />
  );
};